module.exports = __webpack_public_path__ + "img/ecart-seller-color.22018f12.svg";